import React, { useEffect, useState } from "react"
import { Button, Nav } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux"
import { withRouter, Link } from "react-router-dom";
import styled from "styled-components";
import { fetchTenant, fetchTenantInvoiceDetails, updateTenant } from "../app/actions";
import AddEditTenantModal from "./AddEditTenantModal";
import SignInToTenantModal from "./SignInToTenantModal";
import TenantFeatureFlags from "./TenantFeatureFlags";
import TenantLanguages from "./TenantLanguages";
import TenantPaymentMethod from "./TenantPaymentMethod";
import TenantMigration from "./TenantMigration";
import UserTenantConnections from "./UserTenantConnections";
import Overview from "../components/tenantoverview/Overview"

const TabContent = styled.div`
    padding-top: 2em;
`

const TenantSummary = styled.div`
    padding: 1em;
    background: #e6e6e6;
    margin-top: 1em;
    margin-bottom: 1em;
    border-radius: 1em;
`

const ButtonBar = styled.div`
    display: flex;
    justify-content: space-between;
`

const InfoLabel = styled.span`
    width: 100px;
    display: inline-block;
    color: darkgrey;
    white-space: nowrap;
`

const RightInfoLabel = styled(InfoLabel)`
    width: 60px;
`

const TenantSummaryHeader = styled.div`
    display: flex;
    justify-content: space-between;
`

const TenantView = ({match}) => {
    const id = match.params.id;
    const tab = match.params.tab || "o";
    const fetchingTenant = useSelector(state => state.app.fetchingTenant)
    const tenant = useSelector(state => state.app.tenant)
    const token = useSelector(state => state.app.token)
    const tenantInvoiceDetails = useSelector(state => state.app.tenantInvoiceDetails)
    const dispatch = useDispatch()
    const [showAddEditModal, setShowAddEditModal] = useState(false)
    const [showSignInModal, setShowSignInModal] = useState(false)

    const hideAddEditModal = () => {
        setShowAddEditModal(false)
    }

    const handleAddEditSave = (tenant) => {
        dispatch(
            updateTenant(
                tenant.id, 
                tenant.FullName, 
                tenant.ShortName, 
                tenant.Type, 
                tenant.Active, 
                tenant.Live, 
                tenant.BusinessStatus, 
                tenant.BusinessComment, 
                tenant.PrimaryContact, 
                tenant.SecondaryContact
            )
        )
            .then(()=>{
                dispatch(fetchTenant(id))
                setShowAddEditModal(false)
            })
    }

    useEffect(()=>{
        dispatch(fetchTenant(id))
        dispatch(fetchTenantInvoiceDetails(id))
    }, [])

    const handleSignInClick = () => {
        setShowSignInModal(true)
    }

    const hideSignInModal = () => {
        setShowSignInModal(false)
    }

    console.log(process.env.REACT_APP_ENVIRONMENT)

    return <div>
        <ButtonBar>
            <Button as={Link} to={"/tenants"}>Tenants</Button>
            <Button onClick={()=>{
                setShowAddEditModal(true);
            }}>Redigera</Button>
        </ButtonBar>
        {fetchingTenant && <TenantSummary>
            Loading...
        </TenantSummary>}
        {!fetchingTenant && <TenantSummary>
            <TenantSummaryHeader>
                <h4>
                    Tenant #{tenant && tenant.id}
                </h4>
                <Button onClick={handleSignInClick} variant="success">Sign in as</Button>
            </TenantSummaryHeader>
            <div style={{display: "flex", marginTop: "1em"}}>
                <div style={{ flex: 1}}>
                    <div>
                        <InfoLabel>Full Name:</InfoLabel> {tenant && tenant.FullName}
                    </div>
                    <div>
                        <InfoLabel>Short Name:</InfoLabel> {tenant && tenant.ShortName}
                    </div>
                    <div>
                        <InfoLabel>DB_NAME:</InfoLabel> {tenant && tenant.DB_NAME}
                    </div>
                    <div>
                        <InfoLabel>DB_HOST:</InfoLabel> {tenant && tenant.DB_HOST}
                    </div>
                </div>
                <div style={{ flex: 1, marginLeft: "4em"}}>
                    <div>
                        <RightInfoLabel>Active:</RightInfoLabel> {tenant && tenant.Active}
                    </div>
                    <div>
                        <RightInfoLabel>Type:</RightInfoLabel> {tenant && tenant.Type}
                    </div>
                    <div>
                        <RightInfoLabel>Live:</RightInfoLabel> {tenant && tenant.Live}
                    </div>
                    <div>
                        <RightInfoLabel>Status:</RightInfoLabel> {tenant && tenant.BusinessStatus} <i>{tenant && tenant.BusinessComment ? `(${tenant.BusinessComment})` : ''}</i>
                    </div>
                </div>
                <div style={{flex: 1, marginLeft: "4em"}}>
                    <div>
                        <InfoLabel>Contact 1:</InfoLabel> {tenant && tenant.PrimaryContact}
                    </div>
                    <div>
                        <InfoLabel>Contact 2:</InfoLabel> {tenant && tenant.SecondaryContact}
                    </div>
                    <div>
                        <InfoLabel>Updated:</InfoLabel> {tenant && tenant.created_at}
                    </div>
                    <div>
                        <InfoLabel>Created:</InfoLabel> {tenant && tenant.created_at}
                    </div>
                </div>
            </div>
        </TenantSummary>}
        <Nav variant="tabs">
            <Nav.Item>
                <Nav.Link active={tab === "o"} as={Link} to={"/tenants/" + id + "/o"}>
                    Overview
                </Nav.Link>
            </Nav.Item>
            <Nav.Item>
                <Nav.Link active={tab === "u"} as={Link} to={"/tenants/" + id + "/u"}>
                    Users ({tenantInvoiceDetails ? tenantInvoiceDetails.number_of_users : 0})
                </Nav.Link>
            </Nav.Item>
            <Nav.Item>
                <Nav.Link active={tab === "l"} as={Link} to={"/tenants/" + id + "/l"}>
                    Languages ({tenantInvoiceDetails ? tenantInvoiceDetails.number_of_languages : 0})
                </Nav.Link>
            </Nav.Item>
            <Nav.Item>
                <Nav.Link active={tab === "f"} as={Link} to={"/tenants/" + id + "/f"}>
                    Feature flags ({tenantInvoiceDetails ? tenantInvoiceDetails.number_of_feature_flags : 0})
                </Nav.Link>
            </Nav.Item>
            <Nav.Item>
                <Nav.Link active={tab === "p"} as={Link} to={"/tenants/" + id + "/p"}>
                    Payment method
                </Nav.Link>
            </Nav.Item>
            {process.env.REACT_APP_ENVIRONMENT !== "development" && <Nav.Item>
                <Nav.Link active={tab === "m"} as={Link} to={"/tenants/" + id + "/m"}>
                    Migration
                </Nav.Link>
            </Nav.Item>}
        </Nav>
        {!fetchingTenant && <TabContent>
            {tab === "o" && <div>
                <Overview tenant={id}/>
            </div>}
            {tab === "u" && <div>
                <UserTenantConnections tenant={id} />
            </div>}
            {tab === "f" && <div>
                <TenantFeatureFlags tenant={id} />
            </div>}
            {tab === "l" && <div>
                <TenantLanguages tenant={id} />
            </div>}
            {tab === "p" && <div>
                <TenantPaymentMethod tenant={id} />
            </div>}
            {tab === "m" &&  <div>
                <TenantMigration />
            </div>}
        </TabContent>}
        <AddEditTenantModal editTenant={tenant} show={showAddEditModal} onHide={hideAddEditModal} onSave={handleAddEditSave}/>
        <SignInToTenantModal tenant={tenant} show={showSignInModal} onHide={hideSignInModal}/>
    </div>
}

export default withRouter(TenantView)
